import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b04b8f6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-main" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "logo-title" }
const _hoisted_6 = { class: "contact" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "lh20" }
const _hoisted_9 = { class: "color2680EB fw" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "header-main-app"
}
const _hoisted_13 = { class: "contact contact-app" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "lh20" }
const _hoisted_16 = { class: "color2680EB fw" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "logo-img",
          src: require('@/assets/img/header/logo.png')
        }, null, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.headerText.LOGO_TITLE), 1)
      ]),
      (_ctx.store.state.deviceType === '1')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_menu, {
              "default-active": _ctx.defaultActive,
              class: "main-menu",
              mode: "horizontal",
              ellipsis: false
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerText.menus, (menu) => {
                  return (_openBlock(), _createBlock(_Transition, {
                    key: menu.id
                  }, {
                    default: _withCtx(() => [
                      (menu.children&&!menu.notShow)
                        ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                            key: 0,
                            class: _normalizeClass(_ctx.route.path === menu.path?'menu-active':''),
                            onClick: ($event: any) => (_ctx.handleRoute(menu)),
                            index: menu.path
                          }, {
                            title: _withCtx(() => [
                              _createTextVNode(_toDisplayString(menu.name), 1)
                            ]),
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (subMenu) => {
                                return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                                  key: subMenu.id,
                                  onClick: ($event: any) => (_ctx.handleRoute(subMenu)),
                                  index: subMenu.path
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(subMenu.name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "index"])), [
                                  [_vShow, !subMenu.notShow]
                                ])
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick", "index"]))
                        : _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                            key: 1,
                            onClick: ($event: any) => (_ctx.handleRoute(menu)),
                            index: menu.path
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(menu.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick", "index"])), [
                            [_vShow, !menu.notShow]
                          ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["default-active"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("img", {
                class: "phone-img",
                src: require('@/assets/img/header/phone.png')
              }, null, 8, _hoisted_7),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, _toDisplayString(_ctx.headerText.SERVICE_TEL), 1),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.headerText.PHONE_NUM), 1)
              ])
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.store.state.deviceType === '2')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.menuOpen)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuOpen=true)),
                  class: "app-menu-img cursor",
                  src: require('@/assets/img/header/menu-o.png')
                }, null, 8, _hoisted_10))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuOpen = false)),
                  class: "app-menu-img cursor",
                  src: require('@/assets/img/header/menu-c.png')
                }, null, 8, _hoisted_11)),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (_ctx.menuOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_el_menu, {
                        "default-active": _ctx.defaultActive,
                        class: "main-menu",
                        ellipsis: false
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerText.menus, (menu) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: menu.id
                            }, [
                              (menu.children&&!menu.notShow)
                                ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                    key: 0,
                                    index: menu.path
                                  }, {
                                    title: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(menu.name), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu.children, (subMenu) => {
                                        return _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                                          key: subMenu.id,
                                          onClick: ($event: any) => (_ctx.handleRoute(subMenu)),
                                          index: subMenu.path
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(subMenu.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick", "index"])), [
                                          [_vShow, !subMenu.notShow]
                                        ])
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["index"]))
                                : _withDirectives((_openBlock(), _createBlock(_component_el_menu_item, {
                                    key: 1,
                                    onClick: ($event: any) => (_ctx.handleRoute(menu)),
                                    index: menu.path
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(menu.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "index"])), [
                                    [_vShow, !menu.notShow]
                                  ])
                            ], 64))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["default-active"]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("img", {
                          class: "phone-img",
                          src: require('@/assets/img/header/phone.png')
                        }, null, 8, _hoisted_14),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, _toDisplayString(_ctx.headerText.SERVICE_TEL), 1),
                          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.headerText.PHONE_NUM), 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}